// Le regole condivise dalle parti del pannello delle concessioni (`UserRolesPanel`,
// `ConcessioniPerRuolo`, `FormConcessione`).

// Come la chiave di una concessione scrive il gruppo nullo. Al servizio va comunque `null`,
// che è ciò che il backend legge come «ogni gruppo, presenti e futuri» (D6).
export const OGNI_GRUPPO = '__ogni__';

export const TESTO_OGNI_GRUPPO = 'Ogni gruppo, presenti e futuri';

// Come si riconosce una concessione fra le altre: la coppia ruolo+gruppo. Il gruppo nullo
// entra nella chiave col suo nome, perche' «Validatore su ogni gruppo» e «Validatore su
// Fatture» sono due concessioni diverse e non due scritture della stessa.
export const chiaveConcessione = (roleId, groupId) => `${roleId}:${groupId || OGNI_GRUPPO}`;
